// src/modules/persistence/sceneSnapshotMode.js
//
// Global flag: scene'in snapshot'tan yüklendiğini işaretler.
// Load akışı `markSnapshotLoaded()` çağırır → sonraki 2 saniye boyunca
// restore-side rebuild/layout hook'ları skip eder → snapshot mesh'leri
// korunur, duplicate yok. 2 saniye sonra otomatik clear → drawing-time'da
// hook'lar normal çalışır.
//
// Süre yaklaşımı: Redux hydration sırasında effect'ler multiple kez
// tetiklenir, her tetiklenmede skip etmek lazım. Tek-seferlik skip yetmez.
// Süre dışı kullanıcı etkileşimleri normal işler.

const SNAPSHOT_WINDOW_MS = 2000;

export const sceneSnapshotMode = {
  /** Son load akışının zamanı (performance.now). 0 → henüz load olmadı. */
  loadedAt: 0,
};

function _now() {
  return typeof performance !== 'undefined' ? performance.now() : Date.now();
}

/** Load akışı bu fonksiyonu çağırır — timestamp güncellenir, 2sn pencere açılır. */
export function markSnapshotLoaded() {
  sceneSnapshotMode.loadedAt = _now();
}

/** Snapshot pencere içinde miyiz? Hook'lar her tetiklenmede sorar. */
export function isWithinSnapshotWindow() {
  if (sceneSnapshotMode.loadedAt === 0) return false;
  return (_now() - sceneSnapshotMode.loadedAt) < SNAPSHOT_WINDOW_MS;
}

/**
 * @deprecated Eski API — ref-tabanlı bir-kez-skip semantiği.
 * Yeni hook'lar isWithinSnapshotWindow kullansın.
 *
 * Geriye uyumluluk için tutuluyor. Zaman penceresine bağlı şekilde döner:
 * pencere içinde true (skip), dışında false. Ref güncellemez (gerek yok).
 */
export function shouldSkipForSnapshot(_ref) {
  return isWithinSnapshotWindow();
}
